import { render, staticRenderFns } from "./InGameLeaderBoard.vue?vue&type=template&id=780ca4e5&"
import script from "./InGameLeaderBoard.vue?vue&type=script&lang=js&"
export * from "./InGameLeaderBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports